import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/activity',
  component: LAYOUT,
  name: 'Activity',
  redirect: '/activity/detail',
  meta: {
    title: '活动详情',
  },
  children: [
    {
      path: 'detail',
      name: 'ActivityDetail',
      meta: {
        title: '活动详情',
      },
      component: () => import('@/views/activity/detail'),
    },
  ],
};
